import { version } from "../package.json";

export const VERSION = version;

export enum MediaQuery {
  lg = "(min-width: 1024px)",
  md = "(min-width: 768px)",
  sm = "(min-width: 480px)",
  xl = "(min-width: 1280px)",
}

export const MQL_SM = window.matchMedia(MediaQuery.sm);
export const MQL_MD = window.matchMedia(MediaQuery.md);
export const MQL_LG = window.matchMedia(MediaQuery.lg);
export const MQL_XL = window.matchMedia(MediaQuery.xl);

export const MQL_MOTION = window.matchMedia("(prefers-reduced-motion: reduce)");
